import { useState, useEffect } from 'react';
import { useApi, googleAuthApiRef, githubAuthApiRef } from '@backstage/core-plugin-api';

interface UserProfile {
  displayName: string;
  email: string;
  loading: boolean;
}

export function useUserProfile(): UserProfile {
  const googleAuth = useApi(googleAuthApiRef);
  const githubAuth = useApi(githubAuthApiRef);
  const [profile, setProfile] = useState<UserProfile>({
    displayName: '',
    email: '',
    loading: true,
  });

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      let gcpName = '';
      let gcpEmail = '';
      let ghName = '';
      let ghEmail = '';

      // Try GCP first
      try {
        const token = await googleAuth.getAccessToken(['openid', 'profile', 'email'], { optional: true });
        if (token) {
          const gProfile = await googleAuth.getProfile();
          gcpName = gProfile?.displayName ?? '';
          gcpEmail = gProfile?.email ?? '';
        }
      } catch {
        // Not signed in to GCP
      }

      // Always fetch GitHub as fallback
      try {
        const token = await githubAuth.getAccessToken(['user:email'], { optional: true });
        if (token) {
          const ghProfile = await githubAuth.getProfile();
          ghName = ghProfile?.displayName ?? '';
          ghEmail = ghProfile?.email ?? '';
        }
      } catch {
        // Not signed in to GitHub
      }

      if (cancelled) return;

      const isFoundationEmail = gcpEmail.toLowerCase().endsWith('@foundation.badal.io');
      setProfile({
        displayName: gcpName || ghName,
        email: (gcpEmail && !isFoundationEmail) ? gcpEmail : ghEmail,
        loading: false,
      });
    };

    load();
    return () => { cancelled = true; };
  }, [googleAuth, githubAuth]);

  return profile;
}
